import { Form } from '@anytag/shared-atoms';
import { FormAction } from '@anytag/shared-types';
import { SettingsFormSchema } from './schema';
import { Template } from './Template';
import { SettingsFormValues } from './types';
import { defaultSettingsFormValues } from './utils';

export type SettingsFormProps = FormAction<SettingsFormValues>;

export const SettingsForm = ({ onSubmit, defaultValues = defaultSettingsFormValues }: SettingsFormProps) => (
  <Form.Provider className="flex-1" onSubmit={onSubmit} zodSchema={SettingsFormSchema} defaultValues={defaultValues}>
    <Template />
  </Form.Provider>
);

export * from './types';
export { getSettingsFormValues } from './utils';
